import { UseExternalRPCQueryOptions, useRPCQuery } from '@/lib/api/request/use-rpc-query';

type GetUserByIdRequest = {
  userId: string;
};

type GetUserByIdResponse = {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    middleName?: string;
    citizenship: string;
  };
  contacts: {
    email: string | null;
    phone: string;
  };
};

export function useGetUserById({
  params,
  ...opts
}: UseExternalRPCQueryOptions<GetUserByIdResponse, GetUserByIdRequest>) {
  return useRPCQuery({
    ...opts,
    queryKey: ['ignoreLoading'],
    method: useGetUserById.method,
    params,
  });
}

useGetUserById.method = 'get-user-by-id';
